// Container imports
const { SHOW, HIDE } = require('./actions')
const CollectionEditHeaderImageModalRecord = require('./record')

// eslint-disable-next-line complexity
function collectionEditHeaderImageModalReducer(
  state = CollectionEditHeaderImageModalRecord.hide(),
  { type, payload }
) {
  switch (type) {
    case SHOW:
      return new CollectionEditHeaderImageModalRecord(payload)
    case HIDE:
      return null
    default:
      return state
  }
}

module.exports = collectionEditHeaderImageModalReducer
